// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3HfR4","inner":"Footer_inner__3B4mL","nextIcon":"Footer_nextIcon__j8kve","innerLeft":"Footer_innerLeft__1r1Fq"};